module.exports = __webpack_public_path__ + "static/media/google~PQtkgTLo.ecc84433.png";